import {Box, Button, Slider, Typography} from '@viptech/react-components'
import {useState} from 'react'
import {Input} from '../../../../../../../../components/input/Input'
import api, {Camera} from '../../../../../../../../services/api'
import {StepperModalActionsButtonContainer} from '../../../styles'
import Card from '../../common/components/Card'
import {ChosenObject} from '../../StepperModal'
import {LabelsSlider} from '../config-step/ConfigStepBase'
import {ContainerConfigPersonalized, ContainerContentPersonalized, ContainerFpsComponent} from './ConfigStepPersonalizedBase'

type ConfigStepProps = {
  nextFunction: (index: number, resume: string) => void
  returnFunction: (index: number) => void
  setChosen: (choices: Partial<ChosenObject>) => void
  chosen: ChosenObject | null
  isEdit: boolean
  camera: Camera | null
}

const allowedFPSConfigurationsValues = ['10', '15', '20', '25', '30']

const ConfigStepObjectPersonalized = (props: ConfigStepProps) => {
  const {nextFunction, returnFunction, setChosen, isEdit, chosen, camera} = props

  const functionNextButton = () => {
    setChosen({...objectToMonitoring, confidence: objectToMonitoring.confidence / 100})
    if (camera?.configuration.cameraFps !== cameraFps) api.camera.updateCamera(camera?.id!, {configuration: {cameraFps}})
    nextFunction(3, 'Concluído')
  }

  const [objectToMonitoring, setObjectToMonitoring] = useState({
    distance: chosen?.distance,
    confidence: chosen && chosen.confidence ? chosen.confidence * 100 : 0,
    speedLimit: chosen?.speedLimit,
  })

  const [cameraFps, setCameraFps] = useState(camera?.configuration.cameraFps)

  function LabelText({label, text}: {label: string; text: string | number}) {
    return (
      <Box>
        <Typography variant='span' size='16px' style={{fontWeight: 500}}>
          {label}
        </Typography>
        <Typography variant='p' size='12px' color='#8E8E8E'>
          {text}
        </Typography>
      </Box>
    )
  }

  return (
    <ContainerConfigPersonalized>
      <ContainerContentPersonalized>
        <Box display='flex' direction='row' width='100%' justify='space-between' columnGap='80px'>
          <Box display='flex' direction='column' rowGap='20px' width='50%'>
            <LabelText label='Limite de Velocidade' text='Um evento é gerado quando o limite for atingido' />

            <Input.Root
              height='40px'
              labelFontSize='12px'
              fontSize='12px'
              labelColor='#344054'
              borderColor='#98A2B3'
              placeholder='Velocidade'
              min={1}
              controlled
              rightIcon={<p style={{fontSize: '10px'}}>Km/h</p>}
              value={String(objectToMonitoring.speedLimit)}
              onChange={(e) => setObjectToMonitoring((prev) => ({...prev, speedLimit: +e.target.value}))}
            />
          </Box>

          <Box display='flex' direction='column' rowGap='20px' width='50%'>
            <LabelText label='Distância ' text='Distância (em metros) existente entre as linhas' />

            <Box display='flex' columnGap='20px'>
              <Input.Root
                height='40px'
                labelFontSize='12px'
                fontSize='12px'
                labelColor='#344054'
                borderColor='#98A2B3'
                min={1}
                rightIcon={<p style={{fontSize: '10px'}}>m</p>}
                controlled
                value={String(objectToMonitoring.distance)}
                onChange={(e) => setObjectToMonitoring((prev) => ({...prev, distance: +e.target.value}))}
              />
            </Box>
          </Box>
          <Box display='flex' direction='column' rowGap='20px' width='50%'>
            <LabelText label='FPS Configurado' text='Valor previamente configurado na sua câmera' />
            <ContainerFpsComponent>
              {allowedFPSConfigurationsValues.map((it) => {
                return (
                  <Card
                    dispatchTo={it}
                    selected={String(cameraFps) === it}
                    initialState={!String(cameraFps)}
                    onClick={() => setCameraFps(Number(it))}
                    key={it}
                  />
                )
              })}
            </ContainerFpsComponent>
          </Box>
        </Box>

        <Box>
          <LabelText
            label='Nível de confiança'
            text='Escolha abaixo o nível de sensibilidade. Uma sensibilidade muito alta irá disparar menos eventos, e um nível muito baixo irá disparar muitos eventos, podendo resultar em falsos positivos.'
          />

          <Slider
            background='linear-gradient(to right,#ff0000bc,  #ff880063 5% 10%, #009d34 21% 70%, #ff880063, #ff0000bc 104% )'
            max={100}
            min={10}
            width='100%'
            bubble={true}
            value={objectToMonitoring.confidence}
            setValue={(e) => setObjectToMonitoring((prev) => ({...prev, confidence: e}))}
          />
          <Box display='flex' align='center' justifyContent='space-between'>
            <LabelsSlider>Baixo demais</LabelsSlider>
            <LabelsSlider>Ideal</LabelsSlider>
            <LabelsSlider>Alto demais</LabelsSlider>
          </Box>
        </Box>
      </ContainerContentPersonalized>

      <StepperModalActionsButtonContainer>
        <Button disabled={isEdit} fontSize='12px' height='40px' width='150px' variant='outlined' color='#8E8E8E' onClick={() => returnFunction(1)}>
          Voltar
        </Button>
        <Button
          fontSize='12px'
          disabledTextColor='#8E8E8E'
          height='40px'
          width='150px'
          onClick={() => functionNextButton()}
          disabled={!objectToMonitoring.speedLimit || !objectToMonitoring.distance}>
          Próximo
        </Button>
      </StepperModalActionsButtonContainer>
    </ContainerConfigPersonalized>
  )
}

export default ConfigStepObjectPersonalized
